import { Icons } from './Icons';
import { useInView } from '../hooks';
import styles from './HowItWorks.module.css';

function HowCard({ icon: IconComp, step, title, body, delay }) {
  const [ref, inView] = useInView(0.2);
  return (
    <div
      ref={ref}
      className={styles.card}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'none' : 'translateY(20px)',
        transition: `all 0.6s ease ${delay}s`,
      }}
    >
      <div className={styles.cardTop}>
        <div className={styles.iconWrap}>
          <IconComp />
        </div>
        <span className={styles.step}>STEP {step}</span>
      </div>
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.cardBody}>{body}</p>
    </div>
  );
}

export default function HowItWorks({ t }) {
  const cards = [
    { icon: Icons.Pools,   step: '01', title: t.card1Title, body: t.card1Body, delay: 0    },
    { icon: Icons.Buyback, step: '02', title: t.card2Title, body: t.card2Body, delay: 0.12 },
    { icon: Icons.Growth,  step: '03', title: t.card3Title, body: t.card3Body, delay: 0.24 },
  ];

  const [ref, inView] = useInView(0.1);

  return (
    <section className={styles.section} id="how-it-works">
      <div className={styles.inner}>
        <div
          ref={ref}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(16px)', transition: 'all 0.6s ease' }}
        >
          <div className={styles.label}>{t.sectionLabel}</div>
          <h2 className={styles.title}>{t.title}</h2>
          <p className={styles.sub}>{t.sub}</p>
        </div>

        <div className={styles.grid}>
          {cards.map(c => (
            <HowCard key={c.step} {...c} />
          ))}
        </div>
      </div>
    </section>
  );
}
